import React, { useCallback, useMemo, useState } from 'react';
import {
  LangMenu, Select, SelectTabs, TitleText,
} from 'components';
import { useScreenWidth } from 'hooks';
import { ScreenWidth } from 'appConstants';
import { useTranslation } from 'react-i18next';
import { SelectOption } from 'types';
import { LocaleKey } from 'utils';
import { TabContentTools } from './tabContentTools';

import styles from './styles.module.scss';

const tools = [
  {
    title: 'Videos_',
    id: 1,
  },
  {
    title: 'Tutorials_',
    id: 2,
  },
  {
    title: 'Banners_',
    id: 3,
  },
  {
    title: 'Documents_',
    id: 4,
  },
];

export const InstrumentsPage = () => {
  const isTablet = useScreenWidth(ScreenWidth.tablet);
  const { t } = useTranslation('tools');
  const [tab, setTab] = useState(0);
  const language = localStorage.getItem('lng') || LocaleKey.en;
  const [langBanner, setLangBanner] = useState(language);

  const onSelect = useCallback((value: SelectOption<number>) => {
    const newIndex = tools.findIndex((item) => item.id === value.value);
    
    if (newIndex !== -1) {
      setTab(newIndex);
    }
  }, []);

  const listStr = useMemo(() => tools.map(({ title }) => t(title)), [t]);

  const listSelectOptions = useMemo(() => tools.map(({ id, title }) => ({
    value: id,
    label: t(title),
  })), [t]);

  const onSelectTab = useCallback((n: number) => {
    if (n >= 0 && n < tools.length) {
      setTab(n);
    }
  }, []);

  return (
    <div className={styles.instruments_container}>
      <div className={styles.pool_top}>
        <TitleText
          text={t('Title_')}
          className={styles.status_top_title}
        />
        <div className={styles.instruments_top_info}>
          {isTablet ? (
            <Select
              options={listSelectOptions}
              onChange={onSelect}
              value={listSelectOptions[tab]}
            />
          )
            : (
              <SelectTabs
                tabTitles={listStr}
                onSelect={onSelectTab}
              />
            )}
          <LangMenu
            langBanner={langBanner}
            onChangeLangBanner={setLangBanner}
            classNameMenu={styles.instruments_lang}
            isLandingPage
          />
        </div>
      </div>
      <TabContentTools 
        data={tools[tab]} 
        langBanner={langBanner}
      />
    </div>
  );
};
